/**
 * AdminStoryStatusPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from "@material-ui/core/Tooltip";
import Link from '@material-ui/core/Link';

// Material UI icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

// application components
import WarningPanel from "../base/WarningPanel";

// application
import {fetchJSON} from "../../operations/communication";
import {
    REST_CALL_UPDATE_SERVER_STORY_STATE,
    REST_SERVER_BASE_URL
} from "../../config";
import {editObject} from "../../operations/editing";


/**
 * Panel for admin page to show story status fetched from server
 *
 * @author Jens Gruschel
 */
class AdminStoryStatusPanel extends React.Component {

    state = {
        disconnected: false,
        storyStatus: []
    };

    componentDidMount() {
        this.refreshData();
        this.timer = setInterval(() => {this.refreshData()}, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    refreshData() {
        this.refreshStoryStatus();
    }

    async refreshStoryStatus() {
        
        const response = await this.fetchStoryStatus();

        if (response) {
            const storyStatus = response.storystatus || [];
            this.setState({
                disconnected: false,
                storyStatus: storyStatus.sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id))
            });
        }
        else {
            this.setState({
                disconnected: true
            });
        }
    }

    render() {

        const { classes } = this.props;

        return <div className={classes.panel}>

            {
                this.state.disconnected && <WarningPanel text="Verbindung zum Server unterbrochen!" />
            }

            <ExpansionPanel defaultExpanded={true}>

                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>Story-Status</Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Status</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Modus</TableCell>
                                <TableCell align="right">Besucher</TableCell>
                                <TableCell>exklusiv</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.storyStatus.map(story => {
                                const state = story.visitors.length > 0 ? "active" : "inactive";
                                const icon = story.visitors.length > 0 ? <PlayCircleFilledIcon color="primary" /> : <RadioButtonUncheckedIcon color="primary" />;
                                const exclusiveVisitors = story.visitors.filter(visitor => visitor.exclusive); // should be only one, but theoretically could be more
                                return <TableRow key={story.id}>
                                    <TableCell>
                                        <Tooltip title={state}>{icon}</Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Link component="button" style={{fontSize: "13px"}} onClick={() => {this.props.editObject(story.id);}}>
                                            {story.name || "unbenannt"}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{story.mode}</TableCell>
                                    <TableCell align="right">
                                        <Tooltip title={
                                            story.visitors.map(
                                                visitor => visitor.name ? visitor.name + " (" + visitor.id + ")": visitor.id
                                            ).join(", ")
                                        }>
                                            <div>{story.visitors.length}</div>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {
                                            exclusiveVisitors.map(
                                                visitor => visitor.name || visitor.id
                                            ).join(", ")
                                        }
                                    </TableCell>
                                </TableRow>;
                            })}
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <Typography>sichtbar sind nur solche Stories, die in letzter Zeit aktiviert wurden</Typography>

        </div>;
    }

    async fetchStoryStatus() {
        try {
            const response = await fetchJSON(
                REST_SERVER_BASE_URL + REST_CALL_UPDATE_SERVER_STORY_STATE.path, {
                    method: REST_CALL_UPDATE_SERVER_STORY_STATE.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + this.props.accessToken
                    }
                }
            );
            return response;
        }
        catch (error) {
            return null;
        }
    }
}

const styles = theme => ({
    panel: {
        width: '100%'
    },
    noLineBreak: {
        maxWidth: 300,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});

const mapStateToProps = state => {
    return {
        accessToken: state.authorization.accessToken
    };
};

export default connect(mapStateToProps, {editObject})(withStyles(styles)(AdminStoryStatusPanel));